export default __webpack_public_path__ + "media/images/toggle_img_small-1e34e0b28799aff99cedabc769a71697.png";